import React, { useEffect, useState } from "react";
import { BiChevronDown } from "react-icons/bi";
import styled from "../../../../theme/styled-components";
import { BaseLabel, BaseText } from "../../../../components/Text";
import { DropDownButton } from "./DropDownButton";
import _ from "lodash";

const StyledDropDown = styled(DropDownButton)`
  margin-left: 20px;
`;

const Menu = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 6px;
  box-sizing: border-box;
  max-height: 200px;
  overflow: scroll;
`;

const Item = styled.div`
  width: 200px;
  height: 50px;
  border-radius: 12px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding-left: 15px;
  box-sizing: border-box;
  cursor: pointer;
  &:hover {
    background-color: ${({ theme }) => theme.colors.offWhite};
  }
  transition: all 0.3s;
`;

const Label = styled(BaseLabel)<any>`
  margin: 0;
  padding-left: 10px;
  color: ${({ theme, isSelected }) => {
    if (isSelected) {
      return theme.colors.vibrantBlue;
    }
  }};
  transition: all 0.3s;
`;

export interface Lang {
  code: string;
  label: string;
}

export interface ILanguageProps {
  languages: Lang[];
  language: string | null;
  onUpdateLanguage: (sortBy: string | null) => void;
}

export function Language(props: ILanguageProps) {
  //
  const { languages, language, onUpdateLanguage } = props;

  const [menuOpen, setMenuOpen] = useState(false);

  // When the user makes their selection close the menu
  useEffect(() => {
    setMenuOpen(false);
  }, [language]);

  let label = <>Language</>;
  const selected = (language) ? _.find(languages, { code: language }) : null;

  if (selected) {
    label = (
      <>
        Language
        <Label isSelected>{selected.label}</Label>
      </>
    );
  }

  return (
    <StyledDropDown
      icon={BiChevronDown}
      label={label}
      menuOpen={menuOpen}
      onClick={() => setMenuOpen(!menuOpen)}
      onCloseMenu={() => setMenuOpen(false)}
      menu={
        <Menu>
          <Item onClick={() => onUpdateLanguage(null)}>
            <Label>Any</Label>
          </Item>

          {languages.map((lang) => (
            <Item key={lang.code} onClick={() => onUpdateLanguage(lang.code)}>
              <Label isSelected={language === lang.code}>{lang.label}</Label>
            </Item>
          ))}
        </Menu>
      }
    />
  );
}
